import React from 'react';

export const SUMMARY_STATS_THEMES = {
    blue: {
        background: "linear-gradient(135deg, #eff6ff 0%, #ffffff 100%)",
        border: "#bfdbfe",
        iconBg: "#dbeafe",
        iconColor: "#2563eb",
        title: "#1d4ed8",
        value: "#1e3a8a",
        divider: "#dbeafe",
    },
    green: {
        background: "linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%)",
        border: "#bbf7d0",
        iconBg: "#dcfce7",
        iconColor: "#16a34a",
        title: "#15803d",
        value: "#14532d",
        divider: "#dcfce7",
    },
    red: {
        background: "linear-gradient(135deg, #fef2f2 0%, #ffffff 100%)",
        border: "#fecaca",
        iconBg: "#fee2e2",
        iconColor: "#dc2626",
        title: "#b91c1c",
        value: "#991b1b",
        divider: "#fee2e2",
    },
    purple: {
        background: "linear-gradient(135deg, #f5f3ff 0%, #ffffff 100%)",
        border: "#ddd6fe",
        iconBg: "#ede9fe",
        iconColor: "#7c3aed",
        title: "#6d28d9",
        value: "#4c1d95",
        divider: "#ede9fe",
    },
    amber: {
        background: "linear-gradient(135deg, #fffbeb 0%, #ffffff 100%)",
        border: "#fde68a",
        iconBg: "#fef3c7",
        iconColor: "#d97706",
        title: "#b45309",
        value: "#92400e",
        divider: "#fef3c7",
    },
};

// Card "chrome" compartida por los resumenes de Gastos y Morosidad: icono
// circular + titulo arriba, contenido libre opcional (children) y una fila
// de estadisticas (items) separadas por lineas divisorias verticales.
const SummaryStatsCard = ({ icon, title, theme, items, children, style }) => {
    const t = SUMMARY_STATS_THEMES[theme];

    return (
        <div
            style={{
                background: t.background,
                border: `1px solid ${t.border}`,
                borderRadius: 14,
                padding: "1.1rem 1.3rem",
                height: "100%",
                ...style,
            }}
        >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div
                    style={{
                        width: 34,
                        height: 34,
                        borderRadius: "50%",
                        background: t.iconBg,
                        color: t.iconColor,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "1rem",
                        flexShrink: 0,
                    }}
                >
                    <i className={icon} />
                </div>
                <span style={{ fontWeight: 700, fontSize: "1rem", color: t.title }}>{title}</span>
            </div>

            {children}

            {items && (
                <div
                    style={{
                        display: "flex",
                        marginTop: children ? "0.9rem" : "1rem",
                        ...(children ? { borderTop: `1px solid ${t.divider}`, paddingTop: "0.9rem" } : {}),
                    }}
                >
                    {items.map((item, idx) => (
                        <React.Fragment key={item.label}>
                            {idx > 0 && <div style={{ width: 1, background: t.divider, margin: "0 1.25rem" }} />}
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontSize: "0.78rem", color: "#667085", marginBottom: 4 }}>{item.label}</div>
                                <div style={{ fontWeight: 700, fontSize: "1rem", color: t.value }}>{item.value}</div>
                            </div>
                        </React.Fragment>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SummaryStatsCard;
